import {AUTH_TOKEN_STORAGE_KEY, COMPANY_ID_STORAGE_KEY} from '../constants/storageConstants';

export function login(jwtToken, companyId) {
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, jwtToken);
  localStorage.setItem(COMPANY_ID_STORAGE_KEY, companyId);
}

export function logout(client) {
  if (client) client.resetStore();
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  localStorage.removeItem(COMPANY_ID_STORAGE_KEY);
  window.location = '#/login';
}
